<template>
    <div class="body-container">
        <BannerSection title="Prestamos con mal buró"
                       subtitle="Rápido, seguro y sin dejar de usar tu auto" />
        <PerksComponent></PerksComponent>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class="title"><b>Prestamos con mal buró</b></h1>
                    <p class="regular-text">
                        ¿Te imaginas obtener un préstamo sin importar tu Buró de Crédito? Si tienes un auto, puedes
                        hacerlo realidad.
                    </p>
                    <p class="regular-text">
                        Aquí en Ibancar, te ofrecemos una solución accesible, rápida y confiable para conseguir el
                        dinero que necesitas sin complicaciones.
                    </p>
                    <br>
                    <h2 class="h2-title">
                        <b>¡Obtén financiación con tu auto como garantía!</b>
                    </h2>
                    <p class="regular-text">
                        ¿Tienes un auto? Entonces ya cuentas con el respaldo que necesitas para obtener un préstamo sin
                        importar tu historial crediticio. Con Ibancar, puedes solicitar un <a
                           href="https://ibancar.mx/prestamos-con-mal-historial"
                           target="_blank">préstamo con mal historial</a> y
                        acceder al dinero que necesitas de forma rápida y sencilla.
                    </p>
                    <p class="regular-text">
                        <b>Sigue manejando tu auto mientras obtienes el dinero que necesitas para cumplir tus metas, sin
                            preocuparte por tu historial en Buró de Crédito.</b>
                    </p>
                    <br>
                    <span>
                        <h3 class="h2-title"><b>¿Cómo funcionan los préstamos sin buró?</b></h3>
                    </span>
                    <p class="regular-text">
                        Nuestros préstamos son simples y efectivos. Aquí te explicamos cómo funciona nuestro proceso:
                    </p>
                    <ol>
                        <li class="regular-text">
                            <p class="regular-text"><b>Solicita en línea en menos de un minuto: </b>Ingresa los datos de
                                tu vehículo, como marca, modelo, año y kilometraje. Es necesario contar con la factura
                                del auto, ya sea de agencia o refacturada.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Recibe una preaprobación inmediata</b>: Con la información
                                ingresada, te hacemos una oferta en segundos para que sepas cuánto dinero puedes
                                recibir.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Envía tu documentación:</b> Un ejecutivo personalizado te guiará
                                en el envío de tus documentos. Todo el proceso es en línea, sin necesidad de salir de
                                casa.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Agendamos una visita técnica</b>: Un profesional revisará el
                                vehículo y recogerá la factura. La inspección es 100% segura y se realiza en tu
                                domicilio.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Firma el contrato:</b> Un agente de Ibancar acudirá a tu
                                domicilio para la firma del contrato, la revisión final del auto y la recolección de la
                                factura.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Recibe tu dinero en el mismo día:</b> Una vez firmado el
                                contrato, realizamos la transferencia de inmediato para que tengas el dinero en tu
                                cuenta en menos de 24 horas.</p>
                        </li>
                    </ol>
                    <p class="regular-text">Con Ibancar, todo el proceso para obtener un <a
                           href="https://ibancar.mx/">préstamo con tu auto como garantía</a> es transparente, rápido y
                        pensado para tu comodidad. ¡Comienza hoy mismo!</p>
                    <br>

                    <h3 class="h2-title"><b> Beneficios de elegirnos</b></h3>
                    <ul>
                        <li class="regular-text">
                            <p class="regular-text"><b>Aceptamos a personas incluso en Buró de Crédito:</b> Entendemos
                                que todos pueden enfrentar dificultades financieras. Por eso, ofrecemos soluciones
                                inclusivas sin importar tu historial crediticio. Aquí, tu auto es tu crédito.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Proceso en línea:</b> Desde tu casa o trabajo, sin papeleos
                                innecesarios. Disfruta de la comodidad de gestionar tu préstamo desde cualquier lugar y
                                en cualquier momento. Nuestro proceso digital simplifica cada paso, asegurando que todo
                                sea rápido y sin complicaciones.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Conservas tu auto:</b> A diferencia de los empeños tradicionales,
                                sigues manejando tu auto mientras está en garantía por el préstamo. Tu movilidad y
                                libertad no se verán comprometidas.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Pagos claros y accesibles: </b>Mensualidades fijas y sin
                                sorpresas. Además, ofrecemos pagos anticipados (con penalización del 1% del capital
                                anticipado), diferentes formas de pago, y la posibilidad de elegir la fecha de pago que
                                mejor se adapte a ti</p>
                        </li>
                    </ul>

                    <br>
                    <h2 class="h2-title">
                        <b>¿Qué significa 'préstamos sin buró'?</b>
                    </h2>
                    <p class="regular-text">Los préstamos sin buró son opciones de financiación que no consideran tu
                        historial crediticio como requisito principal. En lugar de eso, tu auto se convierte en el
                        respaldo para garantizar el préstamo.</p>
                    <p class="regular-text">Esto los hace ideales para personas con mal historial en Buró de Crédito o
                        sin historial en
                        absoluto.</p>
                        <br>
                    <h3 class="h3-title">
                        <b>¿Cuáles son los requisitos para solicitar un préstamo sin buró?</b>
                    </h3>
                    <ul>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                Ser mayor de edad y contar con una identificación oficial (INE).
                            </p>
                        </li>
                        <br>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                Ser propietario de un vehículo con factura a tu nombre.
                            </p>
                        </li>
                        <br>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                Proporcionar comprobante de domicilio e ingresos.
                            </p>
                        </li>
                        <br>
                    </ul>
                    <p class="regular-text">Con estos documentos, puedes iniciar tu solicitud en línea y obtener tu
                        préstamo en cuestión de horas.</p>
                        <br>
                    <h3 class="h3-title">
                        <b>Rápido, seguro y sin dejar de usar tu auto</b>
                    </h3>
                    <p class="regular-text">En Ibancar entendemos tus necesidades y respetamos tu tiempo. Por eso,
                        nuestros préstamos personales están diseñados para brindarte la tranquilidad de obtener el
                        dinero que necesitas sin interrumpir tu día a día. Además, si buscas una solución urgente,
                        nuestro préstamo rápido es la opción ideal para ti.</p>
                </div>
            </div>
        </div>


        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 0rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>


        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <br>
                    <span class="bold-text">
                        <br>
                        <b>
                            <h2 class="h2-title">FAQs sobre los préstamos sin buró</h2>
                        </b>
                        <br>
                    </span>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Cuánto dinero puedo obtener?</p>
                        <p class="regular-text">El monto depende del valor de tu auto. Ofrecemos préstamos desde $12,000
                            hasta $120,000 MXN.</p>
                    </div>
                    <br>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Qué pasa si no puedo pagar a tiempo?
                        </p>
                        <p class="regular-text">Te ayudaremos a encontrar una solución. Contáctanos antes de que el
                            problema se agrave.</p>
                    </div>
                    <br>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿El préstamo afecta la propiedad de mi auto? </p>
                        <p class="regular-text">No, tu auto sigue siendo tuyo y puedes usarlo como siempre mientras
                            realizas los pagos.
                        </p>
                    </div>
                    <br>
                    <p class="regular-text">En Ibancar, sabemos que las circunstancias financieras pueden ser
                        complicadas. Por eso, estamos aquí para ofrecerte una alternativa confiable y sin prejuicios.
                    </p>
                    <p class="regular-text">Si estás buscando opciones como un empeño de auto en México pero sin los
                        inconvenientes tradicionales, somos tu mejor elección.</p>
                    <p class="regular-text">
                        ¡Solicita tu préstamo hoy y aprovecha el valor de tu auto sin preocuparte por tu historial en
                        Buró de Crédito!
                    </p>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamoTituloDeCarro',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Prestamos con mal buró | IBANCAR',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Obtén tu préstamo sin checar buró con IBANCAR. Hasta $120,000 de forma rápida, si dispones de vehículo. Haz ya tu solicitud en línea y recibe el dinero en 1 día.'
                    },
                    {
                        name: 'keywords',
                        content: 'que es un prestamo prendario automotor, prestamo automotor'
                    }
                ],
                link: [
                    { href: 'https://ibancar.mx/prestamo-prendario-automotor', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    },
    mounted() {
    document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
      if (el.innerText.includes('"@type": "FAQPage"')) {
        el.remove();
      }
    });
    const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Qué son los préstamos sin Buró?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Son préstamos diseñados para personas que no cuentan con un historial crediticio favorable o que están en Buró de Crédito, permitiéndoles acceder a financiamiento."
        }
      },
      {
        "@type": "Question",
        "name": "¿Puedo obtener un préstamo sin Buró si tengo mal historial crediticio?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí, en Ibancar ofrecemos préstamos sin importar tu historial crediticio, utilizando tu carro como garantía."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué necesito para solicitar un préstamo sin Buró?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Debes ser mayor de edad, ser propietario del carro y contar con ingresos comprobables."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué documentos debo presentar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Necesitarás tu identificación oficial, comprobante de ingresos, comprobante de vivienda, tarjeta de circulación y fotos de tu carro."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuánto tiempo tarda en aprobarse el préstamo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "El proceso es rápido y generalmente recibirás el dinero en menos de 24 horas tras la aprobación."
        }
      },
      {
        "@type": "Question",
        "name": "¿Puedo seguir usando mi carro mientras dure el préstamo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sí, puedes seguir utilizando tu carro normalmente mientras dure el préstamo."
        }
      }
    ]
  };
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify(faqData);
    document.head.appendChild(script);
  }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 3rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}


.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {
    .title {
        font-size: 23px;
        line-height: 25px;
    }

    .h2-title {
        font-size: 18px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 20px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>